export default "__VITE_PUBLIC_ASSET__86c69e04__"